import React from "react";
import { ClientAssetDataSpan } from "../types";
import { Button, List, ListItem } from "@mui/material";
import { useAppDispatch } from "./store/hooks";
import { setActiveStructureByName } from "./store/reducers/deviceLinkingAppStoreSlice";

type SpanActiveObjectDetailedInfoProps = {
    className?: string;
    activeSpan: ClientAssetDataSpan;
};

export default function SpanActiveObjectDetailedInfo(props: SpanActiveObjectDetailedInfoProps): JSX.Element {
    const dispatch = useAppDispatch();
    return (
        <div className={props.className}>
            <h1>Span Selected</h1>
            <List>
                <ListItem>
                    <b>Span:</b> {props.activeSpan.span_name}
                </ListItem>
                <ListItem>
                    <b>Start Structure:</b>{" "}
                    <Button onClick={() => dispatch(setActiveStructureByName(props.activeSpan.start_structure))}>
                        {props.activeSpan.start_structure}
                    </Button>
                </ListItem>
                <ListItem>
                    <b>End Structure:</b>{" "}
                    <Button onClick={() => dispatch(setActiveStructureByName(props.activeSpan.end_structure))}>
                        {props.activeSpan.end_structure}
                    </Button>
                </ListItem>
                <ListItem>
                    <b>Section Name:</b> {props.activeSpan.section_name}
                </ListItem>
            </List>
        </div>
    );
}
